import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "clearfix" };
const _hoisted_2 = {
    key: 0,
    ref: "containerDiv",
    class: "legend-container"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "legend-item critical" }, [
    /*#__PURE__*/ _createElementVNode("svg", { viewBox: "0 0 10 10" }, [
        /*#__PURE__*/ _createElementVNode("rect", {
            x: "0",
            y: "4",
            width: "10",
            height: "2"
        })
    ]),
    /*#__PURE__*/ _createTextVNode("Alarm limit")
], -1 /* HOISTED */);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "legend-item warning" }, [
    /*#__PURE__*/ _createElementVNode("svg", { viewBox: "0 0 10 10" }, [
        /*#__PURE__*/ _createElementVNode("rect", {
            x: "0",
            y: "4",
            width: "10",
            height: "2"
        })
    ]),
    /*#__PURE__*/ _createTextVNode("Warning limit")
], -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "legend-item critical" }, [
    /*#__PURE__*/ _createElementVNode("svg", { viewBox: "0 0 10 10" }, [
        /*#__PURE__*/ _createElementVNode("rect", {
            x: "0",
            y: "0",
            width: "10",
            height: "10"
        })
    ]),
    /*#__PURE__*/ _createTextVNode("In Alarm")
], -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "legend-item warning" }, [
    /*#__PURE__*/ _createElementVNode("svg", { viewBox: "0 0 10 10" }, [
        /*#__PURE__*/ _createElementVNode("rect", {
            x: "0",
            y: "0",
            width: "10",
            height: "10"
        })
    ]),
    /*#__PURE__*/ _createTextVNode("In Warning")
], -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "legend-item ok" }, [
    /*#__PURE__*/ _createElementVNode("svg", { viewBox: "0 0 10 10" }, [
        /*#__PURE__*/ _createElementVNode("rect", {
            x: "0",
            y: "0",
            width: "10",
            height: "10"
        })
    ]),
    /*#__PURE__*/ _createTextVNode("OK")
], -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "legend-item no-limit" }, [
    /*#__PURE__*/ _createElementVNode("svg", { viewBox: "0 0 10 10" }, [
        /*#__PURE__*/ _createElementVNode("rect", {
            x: "0",
            y: "0",
            width: "10",
            height: "10"
        })
    ]),
    /*#__PURE__*/ _createTextVNode("No limit set")
], -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_Bar = _resolveComponent("Bar");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.showLegend)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_b_form_checkbox, {
                        modelValue: _ctx.showLimits,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.showLimits) = $event))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\tShow Limits\r\n\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"]),
                    _createTextVNode(),
                    (_ctx.containerWidth >= 700)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_3,
                            _createTextVNode(),
                            _hoisted_4,
                            _createTextVNode(),
                            _hoisted_5,
                            _createTextVNode(),
                            _hoisted_6,
                            _createTextVNode(),
                            _hoisted_7,
                            _createTextVNode(),
                            _hoisted_8
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ], 512 /* NEED_PATCH */))
                : _createCommentVNode("v-if", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", {
            style: _normalizeStyle({ height: _ctx.height + 'px' })
        }, [
            (_ctx.canPlot)
                ? (_openBlock(), _createBlock(_component_Bar, {
                    key: 0,
                    data: _ctx.renderData,
                    options: _ctx.renderOptions
                }, null, 8 /* PROPS */, ["data", "options"]))
                : _createCommentVNode("v-if", true)
        ], 4 /* STYLE */)
    ]));
}
